import React from 'react'

const Home = () => {
    return (
        <div>
            <h1 className="text-6xl uppercase font-bold">Audio Players</h1>
            <p>This is still very much a work in progress...</p>
        </div>
    )
}

export default Home
